import { render, staticRenderFns } from "./PolicyFormSection.vue?vue&type=template&id=733f6cbd"
import script from "./PolicyFormSection.vue?vue&type=script&lang=js"
export * from "./PolicyFormSection.vue?vue&type=script&lang=js"
import style0 from "./PolicyFormSection.vue?vue&type=style&index=0&id=733f6cbd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports